import React from "react";

import { SelectedStateProvider } from "./selectedState";
import { UrlFiltersProvider } from "./urlFilter";

export const SelectedFiltersProvider: React.FC = ({ children }) => (
  <UrlFiltersProvider>
    <SelectedStateProvider>{children}</SelectedStateProvider>
  </UrlFiltersProvider>
);
